import { render, staticRenderFns } from "./RegisterDiploma.vue?vue&type=template&id=9943b790"
import script from "./RegisterDiploma.vue?vue&type=script&lang=js"
export * from "./RegisterDiploma.vue?vue&type=script&lang=js"
import style0 from "./RegisterDiploma.vue?vue&type=style&index=0&id=9943b790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports